// Meta Advantage+ audience segment (user_segment_key breakdown) helpers. Pure, dep-free.
// Literal Meta values vary by account, so known spellings map to friendly labels and
// anything else is title-cased.

const USER_SEGMENT_LABELS = {
    new: 'New audience',
    new_audience: 'New audience',
    prospecting: 'New audience',
    engaged: 'Engaged audience',
    engaged_audience: 'Engaged audience',
    existing: 'Existing customers',
    existing_customers: 'Existing customers',
    existing_customer: 'Existing customers',
    unknown: 'Unclassified',
}

// Normalized segment key off a user_segment_key-broken insight row.
export const userSegmentKeyOf = (row) => {
    const raw = row?.user_segment_key
    if (raw === undefined || raw === null || raw === '') {
        return 'unknown'
    }
    return String(raw).trim().toLowerCase()
}

// Human label for a segment key; unseen values are title-cased from snake_case.
export const userSegmentLabel = (key) => {
    if (USER_SEGMENT_LABELS[key]) {
        return USER_SEGMENT_LABELS[key]
    }
    const text = String(key || 'unknown').replace(/_/g, ' ')
    return text.charAt(0).toUpperCase() + text.slice(1)
}
